import React, { HTMLAttributes, FC } from "react";
import classNames from "classnames";

const Row: FC<HTMLAttributes<HTMLDivElement>> = props => {
  return <div {...props} className={classNames("datatable-row", props.className)} />;
};

export default Row;
